import { useState } from 'react';
import Head from "next/head";
import Image from "next/image"
import { useRouter } from 'next/router';
import tnpscwebbanner from "../../assets/images/Tnpsc/TNPSC-GRP-I-PrelimsMock-Test-Web-Banner.jpg";
import tnpscmobbanner from "../../assets/images/Tnpsc/TNPSC-GRP-I-PrelimsMock-Test-Mobile-Banner.jpg";
// import { NewStudentForm } from '../../components/Tnpsc-Paymentgateway/Tnpscgrp1mocktest';
import callbtn from "../../assets/images/contact/contact_.png";
import Form from "./form";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from "next/link";
import styles from "../sch-test/delhi-prefit.module.css";

export default function MobileCheck() {
  const [mobile, setMobile] = useState('');
  const [studentType, setStudentType] = useState('check');
  const router = useRouter(); 
  const [isloading, setLoading] = useState(false);
  const [existingData, setExistingData] = useState(null);

    const feestructure = [
        { date: "General Studies & Aptitude and Mental Ability", cont: "20th Sept 2026", cont1: "9:30 AM to 12:30 PM" },
       
      ]

  // const checkStudent = async () => {
  //   if (!mobile || mobile.length !== 10) {
  //     alert('Please enter a valid 10-digit mobile number!');
  //     return;
  //   }

  // const token = "NDp4UVRybXJ6Zktvd3c=";
  //  //setLoading(true);

  //   try {
  //   const res = await fetch('https://www.shankariasacademy.com/blog/wp-json/cf7/v2/tnpscgrIIusercheck', {
  //       method: 'POST',
  //       headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}`,
  //       },
  //       body: JSON.stringify({ RegMobile: mobile }),
  //   });

  //   const data = await res.json();
  //   console.log('Mobile:', mobile);
  //   console.log('API Response:', data);
    
  //   if (data.status === 'success') {
  //     const paresedData = data.value
  //     setExistingData(paresedData);
  //       console.log('Mobile found. Opening existing form.');
  //       setStudentType('existing');
  //   } else {
  //       console.log('Mobile not found. Opening new form.');
  //       setStudentType('new');
  //   }

  //   } catch (error) {
  //   console.error('API error:', error);
  //   setStudentType('new');
  //   } finally {
  //   setLoading(false);
  //   }
  //   };

   const prelimlist =[
   
    {list:" Registration Closing Date: 20th  September 2026"},
    {list:" Date of downloading of Mock Test Hall-Ticket: 18th September 2026 at 5:00 PM"},
    {list:" Mode of Mock Test: Only Offline mode"},
    {list:" Mock Test Results: 22nd September 2026 at 6:00 PM"}, 
       
        
    ]

  
  return (
    <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title> TNPSC Group I Prelims State Level Mock Test 2026</title>
            <meta name="title" content="TNPSC Group I Prelims State Level Mock Test 2026" />
            <meta name="description" content="Register for TNPSC Group I Prelims State Level Free Mock Test 2026. Get full syllabus coverage, state ranking, expert feedback & detailed analysis." />
		    <meta name="keywords" content="TNPSC Group I Prelims State Level Mock Test 2026, TNPSC Group I Prelims State Level Mock Test, TNPSC Group I Prelims Mock Test 2026, TNPSC Group I Prelims Mock Test, TNPSC Group II Prelims Mock Test, TNPSC Group I Prelims Mock Test, Group I Prelims Mock Test," />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-I-prelims-mock-test/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content=" TNPSC Group I Prelims State Level Mock Test 2026" />
            <meta property="og:description" content="Register for TNPSC Group I Prelims State Level Free Mock Test 2026. Get full syllabus coverage, state ranking, expert feedback & detailed analysis." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-I-prelims-mock-test/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

      <Navbar title="sch-test" />
      
      <div className="container p-3">
          <h1 className={`${styles.contactheader} pt-2 `}>
              I'M TOP TNPSC Group I Prelims State Level Mock Test 2026
          </h1>

           <div className = "row d-none d-md-block">
                <div className="col">
                    <Image
                        src={tnpscwebbanner}
                        className="img-fluid w-100"
                        alt="tnpsc-web Banner"
                        title="TNPSC Group I Prelims Mock Test 2026" 
                      />
                </div>
            </div>
          
            <div className = "row d-block d-md-none">
                <div className="col">
                      <Image
                          src={tnpscmobbanner}
                          className="img-fluid w-100"
                          alt="tnpsc-mobile Banner"
                          title="TNPSC Group I Prelims Mock Test 2026" 
                        />
                </div>
            </div>
      </div>

       <div className="container-fluid" style={{background: '#F4F6F8'}}>
         <div className="container">     
            <div className="py-2">
              <div className="row">
                <div className="col-12 col-lg-4 order-2 order-lg-1">
                    {[
                       {
                        date: "20th  September 2026",
                        paper: "GS  &  Mental Ability",
                        TypeofExamination: "Objective",
                        reporttime: "Reporting Time : 09:00 AM",
                        time: "9:30 AM to 12:30 PM",
                        icon: "/images/icon/Calender-01.png",
                     },               
                                                        
                     ].map((item, i) => (
                        <div key={i} className="col-12 col-md-12 ">
                           <div className="card h-100 border-0 rounded-4 shadow-lg hover-shadow  transition-all" style={{background: "linear-gradient(180deg, #ffffff, #f9f9ff)",padding: "25px 20px",}} >
                               <div className="card-body text-center d-flex flex-column justify-content-between">
                                <div>
                                    <div className="mb-4">
                                        <Image
                                         src={item.icon}
                                         alt="calendar"
                                         width={60}
                                         height={60}
                                         className="img-fluid"
                                        />
                                    </div>

                                    <h5 className="fw-bold text-dark mb-2">{item.date}</h5>
                                    <p className="fw-semibold text-secondary mb-2"style={{ fontSize: "0.95rem", lineHeight: "1.4" }}>{item.paper}</p>
                                    <p className="fw-semibold mb-3"
                                        style={{ color: "#d9534f", fontSize: "0.95rem" }}
                                    >
                                        {item.reporttime}
                                    </p>
                                    <p>Type of Examination</p>
                                    <p className="fw-semibold mb-3" style={{ color: "#d9534f", fontSize: "0.95rem" }} >
                                        {item.TypeofExamination}
                                    </p>
                                </div>
                                    
                                <div>
                                    <span className="badge text-white px-4 py-3 rounded-pill"
                                       style={{background:"linear-gradient(90deg, #007bff, #004aad)",fontSize: "1rem",letterSpacing: "0.6px",boxShadow: "0 4px 12px rgba(0,0,0,0.2)", }}>
                                        {item.time}
                                    </span>
                                </div>
                                </div>
                           </div>
                        </div>
                    ))}  

                    <section className="py-5">
                        <div className="container">
                                <div className="row">
                                    {/* <div className="card h-100 border-0 rounded-4 shadow-lg hover-shadow  transition-all"
                                        style={{background: "linear-gradient(180deg, #ffffff, #f9f9ff)", padding: "25px 20px",}}>
                                        <p className='col-12 col-md-12  p-2'>All the mock registered candidates need to bring <span style={{color:"#053281"}}> SIA Mock Test Hall Ticket (Hard Copy)</span>  and submit them at the respective exam venue. After due verification of your hall tickets, you will be allowed to enter the exam venue.</p>   
                                    </div> */}
                                </div>
                        </div>

                        <div className="container py-4">
                            <div className="row g-4">
                                <div className="col-12 col-md-12">
                                    <div className="p-4 card h-100 border-0 rounded-4   transition-all"
                                        style={{background: "linear-gradient(180deg, #b5daff, #f9f9ff)"}} >
                                        <h2 className={`${styles.contactheaders} text-center mb-4`}>
                                          Important Dates –  Mock Test 2026
                                        </h2>
                                        <ul className="list-unstyled mb-0">
                                        <li className="mb-2">
                                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <span style={{fontSize: "16px"}}>Registration Closing: 14th Sept – 5:00 PM</span>
                                        </li>
                                        <li className="mb-2">
                                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <span style={{fontSize: "16px"}}>Hall Ticket Download: 16th Sept – 4:00 PM</span>
                                        </li>
                                        <li>
                                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <span style={{fontSize: "16px"}}>Mock Test Results:    22nd Sept – 5:00 PM</span>
                                        </li>
                                        </ul>
                                    </div>
                                </div>

                                <section className="py-2" style={{ background: "#E9EEF3" }}>
                                    <div className="container">
                                        <h2 className={`${styles.contactheaders} text-center mb-2`}>Features of the Mock Test</h2>
                                            <div className="row ">
                                                <div className="col-12 col-md-12">
                                                <ul className="list-group list-group-flush bg-transparent">
                                                    {[
                                                    "High-Impact and Reflection Creating Question",
                                                    "State-Level Rank List",
                                                    "Structured, Real-Time Group I Prelims Exam Experience",
                                                
                                                    ].map((text, i) => (
                                                    <li key={i} className="list-group-item bg-transparent border-0  text-justify fs-7 py-2">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>{text}
                                                    </li>
                                                    ))}
                                                </ul>
                                                </div>
                                            </div>
                                            
                                    </div>     
                                </section>
                            
                            </div>
                        </div>
                    </section>                            
                </div>

                <div className=" col-12 col-lg-8 order-1 order-lg-2 text-center pt-5">
                   {/* <Form /> */}

                   <p className="lead pt-3"><a href="/hallticket" className="btn btn-danger">Click here to download the SIA Hall Ticket</a></p>

                </div>
              </div>
            </div>                
         </div>
       </div>

       <Footer />
    </>
  );
}




